import { AdminForm } from '@components/admin/form/Form'
import ComplementaryItemForm from '@components/balance/complementary-item/form/Form'
import BusinessProfilForm from '@components/business/businessProfile/form/Form'
import { BusinessStatusForm } from '@components/business/businessProfileStatus/form/Form'
import BusinessVerifierForm from '@components/business/businessVerifier/form/Form'
import CompanyForm from '@components/business/company/form/Form'
import CompanyContactForm from '@components/business/companyContact/form/Form'
import { CompanyStatusForm } from '@components/business/companyStatuses/form/Form'
import PolicyForm from '@components/business/policy/form/Form'
import ClusterForm from '@components/cluster/form/Form'
import DominoConfigForm from '@components/dominoConfig/form/Form'
import Event from '@components/event/Event'
import EventForm from '@components/event/form/Form'
import EventsCollectionForm from '@components/eventsCollection/form/Form'
import { ExternalBookingAPIKeyForm } from '@components/externalBookingAPIKey/form/Form'
import FeaturedVenuesForm from '@components/featuredVenues/form/Form'
import LegalDocumentForm from '@components/legalDocument/form/Form'
import LegalDocumentVersionForm from '@components/legalDocumentVersion/form/Form'
import CouponForm from '@components/membership/coupon/form/Form'
import FormQuestionOptionForm from '@components/membership/form-question-option/form/Form'
import FormQuestionForm from '@components/membership/form-question/form/Form'
import { MembershipProfileCurrencyForm } from '@components/membership/membership-profile-currency/form/Form'
import MembershipProfileTagForm from '@components/membership/membership-profile-tag/form/Form'
import MembershipProfileComplementaryItemForm from '@components/membership/membership-profile/complementary-item/form/Form'
import MembershipProfileForm from '@components/membership/membership-profile/form/Form'
import ProgramComplementaryItemForm from '@components/membership/program-complementary-item/form/Form'
import ProgramCurrencyForm from '@components/membership/program-currency/form/Form'
import ProgramForm from '@components/membership/program/form/Form'
import SubscriptionTag from '@components/membership/subscription-tag/SubscriptionTag'
import SubscriptionTagForm from '@components/membership/subscription-tag/form/Form'
import MembershipSubscriptionForm from '@components/membership/subscription/form/Form'
import MembershipTransactionForm from '@components/membership/transaction/form/Form'
import MenuForm from '@components/menu/form/Form'
import NotificationForm from '@components/notifications/form/Form'
import { NotificatinContentForm } from '@components/notification-content/form/Form'
import EventParticipation from '@components/participation/Participation'
import ParticipationStatusForm from '@components/participationStatus/form/Form'
import PerkForm from '@components/perk/form/Form'
import Role from '@components/role/Role'
import SeatingAreaForm from '@components/seatingArea/form/Form'
import SegmentForm from '@components/segment/form/Form'
import SettingForm from '@components/setting/form/Form'
import SevenroomsAudience from '@components/sevenroomsAudience/SevenroomsAudience'
import SevenroomsAudienceForm from '@components/sevenroomsAudience/form/Form'
import SevenroomsVenueGroup from '@components/sevenroomsVenueGroup/SevenroomsVenueGroup'
import SevenroomsVenueGroupForm from '@components/sevenroomsVenueGroup/form/Form'
import UserForm from '@components/user/form/Form'
import { Venue } from '@components/venue/Venue'
import VenueForm from '@components/venue/form/Form'
import VenueTagForm from '@components/venueTag/form/Form'
import VenuesCollectionForm from '@components/venuesCollection/form/Form'
import WhatsappBotSettingForm from '@components/whatsappBotSetting/form/Form'
import { Audience } from '@models/Audience'
import { Cluster } from '@models/Cluster'
import { Currency } from '@models/Currency'
import { Event as EventModel } from '@models/Event'
import { EventsCollection } from '@models/EventsCollection'
import { ExternalBookingAPIKey } from '@models/ExternalBookingAPIKey'
import { FeaturedVenue } from '@models/FeaturedVenue'
import { LegalDocument } from '@models/LegalDocument'
import { LoyaltyTier as LoyaltyTierModel } from '@models/LoyaltyTier'
import { Notification } from '@models/Notification'
import { ReservationStatus } from '@models/ReservationStatus'
import { Role as RoleModel } from '@models/Role'
import { SeatingArea } from '@models/SeatingArea'
import { Segment } from '@models/Segment'
import { TestUser } from '@models/TestUser'
import { User } from '@models/User'
import { VenueWithRelations } from '@models/Venue'
import { VenueSeatingArea } from '@models/VenueSeatingArea'
import { VenueTag } from '@models/VenueTag'
import { VenueType } from '@models/VenueType'
import { VenuesCollection } from '@models/VenuesCollection'
import { ComplementaryItem } from '@models/balance/ComplementaryItem'
import { BusinessProfile } from '@models/business/BusinessProfile'
import { BusinessProfileStatus } from '@models/business/BusinessProfileStatus'
import { Company } from '@models/business/Company'
import { CompanyContact } from '@models/business/CompanyContact'
import { CompanyStatus } from '@models/business/CompanyStatus'
import { Policy } from '@models/business/Policy'
import { Coupon } from '@models/membership/Coupon'
import { FormQuestion, FormQuestionOption } from '@models/membership/Form'
import { MembershipProfile } from '@models/membership/MembershipProfile'
import { MembershipProfileCurrency } from '@models/membership/MembershipProfileCurrency'
import { MembershipProfileTag } from '@models/membership/MembershipProfileTag'
import { Perk } from '@models/membership/Perk'
import { Plan } from '@models/membership/Plan'
import { Program } from '@models/membership/Program'
import { ProgramCurrency } from '@models/membership/ProgramCurrency'
import { Subscription } from '@models/membership/Subscription'
import { SubscriptionTag as SubscriptionTagModel } from '@models/membership/SubscriptionTag'
import { VenueIntegration } from '@models/venue/VenueIntegration'
import { AdyenConfig } from '@models/venue/integrations/AdyenConfig'
import {
  SevenroomsAudience as SevenroomsAudienceModel,
  SevenroomsVenueGroup as SevenroomsVenueGroupModel,
} from '@models/venue/integrations/SevenroomsAudience'
import {
  getAdminInvitesSuccess,
  setSelectedAdminInvite,
} from '@store/AdminInviteReducer'
import { getAdminsSuccess, setSelectedAdmin } from '@store/AdminReducer'
import {
  getAudiencesSuccess,
  setSelectedAudience,
} from '@store/AudiencesReducer'
import { getClustersSuccess, setSelectedCluster } from '@store/ClusterReducer'
import {
  getCurrenciesSuccess,
  setSelectedCurrency,
} from '@store/CurrencyReducer'
import {
  getExternalBookingAPIKeysSuccess,
  setSelectedExternalBookingAPIKey,
} from '@store/ExternalBookingAPIKeyReducer'
import {
  getFeaturedVenuesSuccess,
  setSelectedFeaturedVenues,
} from '@store/FeaturedVenuesReducer'
import {
  getLegalDocumentsSuccess,
  setSelectedLegalDocument,
} from '@store/LegalDocumentReducer'
import {
  getLegalDocumentVersionsSuccess,
  setSelectedLegalDocumentVersion,
} from '@store/LegalDocumentVersionReducer'
import {
  getLoyaltyTiersSuccess,
  setSelectedLoyaltyTier,
} from '@store/LoyaltyTierReducer'
import { getMenusSuccess, setSelectedMenu } from '@store/MenuReducer'
import {
  getNotificationContentsSuccess,
  setSelectedNotificationContent,
} from '@store/NotificationContentReducer'
import {
  getNotificationsSuccess,
  setSelectedNotification,
} from '@store/NotificationReducer'
import {
  getPermissionsSuccess,
  setSelectedPermission,
} from '@store/PermissionReducer'
import { getReservationsSuccess } from '@store/ReservationReducer'
import { getRolesSuccess, setSelectedRole } from '@store/RoleReducer'
import {
  getSeatingAreasSuccess,
  setSelectedSeatingArea,
} from '@store/SeatingAreaReducer'
import { getSegmentsSuccess, setSelectedSegment } from '@store/SegmentReducer'
import { getSettingsSuccess, setSelectedSetting } from '@store/SettingReducer'
import { getTestUsersSuccess } from '@store/TestUserReducer'
import { getUsersSuccess, setSelectedUser } from '@store/UserReducer'
import { getVenuesSuccess } from '@store/VenueReducer'
import {
  getVenueSeatingAreasSuccess,
  setSelectedVenueSeatingArea,
} from '@store/VenueSeatingAreaReducer'
import {
  getVenueTagsSuccess,
  setSelectedVenueTag,
} from '@store/VenueTagReducer'
import { getVenueTypesSuccess } from '@store/VenueTypeReducer'
import {
  getVenuesCollectionsSuccess,
  setSelectedVenuesCollection,
} from '@store/VenuesCollectionReducer'
import {
  getWhatsappBotSettingsSuccess,
  setSelectedWhatsappBotSetting,
} from '@store/WhatsappBotSettingReducer'
import {
  getComplementaryItemsSuccess,
  setSelectedComplementaryItem,
} from '@store/balance/ComplementaryItemReducer'
import {
  getBillingMethodsSuccess,
  setSelectedBillingMethod,
} from '@store/business/BillingMethodReducer'
import {
  getBusinessProfilesSuccess,
  setSelectedBusinessProfile,
} from '@store/business/BusinessProfileReducer'
import {
  getBusinessProfileStatusesSuccess,
  setSelectedBusinessProfileStatus,
} from '@store/business/BusinessProfileStatusReducer'
import {
  getBusinessVerifiersSuccess,
  setSelectedBusinessVerifier,
} from '@store/business/BusinessVerifierReducer'
import {
  getCompanyContactsSuccess,
  setSelectedCompanyContact,
} from '@store/business/CompanyContactReducer'
import {
  getCompaniesSuccess,
  setSelectedCompany,
} from '@store/business/CompanyReducer'
import {
  getCompanyStatusesSuccess,
  setSelectedCompanyStatus,
} from '@store/business/CompanyStatusReducer'
import { getDaysSuccess, setSelectedDay } from '@store/business/DayReducer'
import {
  getPoliciesSuccess,
  setSelectedPolicy,
} from '@store/business/PolicyReducer'
import {
  getShiftsSuccess,
  setSelectedShift,
} from '@store/business/ShiftReducer'
import {
  getCouponsSuccess,
  setSelectedCoupon,
} from '@store/membership/CouponReducer'
import {
  getEventParticipationsSuccess,
  setSelectedParticipation,
} from '@store/membership/EventParticipationReducer'
import {
  getEventsSuccess,
  setSelectedEvent,
} from '@store/membership/EventReducer'
import {
  getEventsCollectionsSuccess,
  setSelectedEventsCollection,
} from '@store/membership/EventsCollectionReducer'
import {
  getFormAnswersSuccess,
  setSelectedFormAnswer,
} from '@store/membership/FormAnswerReducer'
import {
  getFormQuestionOptionsSuccess,
  setSelectedFormQuestionOption,
} from '@store/membership/FormQuestionOptionReducer'
import {
  getFormQuestionsSuccess,
  setSelectedFormQuestion,
} from '@store/membership/FormQuestionReducer'
import { getMembershipIncomingRenewalsSuccess } from '@store/membership/MembershipIncomingRenewalReducer'
import {
  getMembershipProfileComplementaryItemsSuccess,
  setSelectedMembershipProfileComplementaryItem,
} from '@store/membership/MembershipProfileComplementaryItemReducer'
import {
  getMembershipProfileCurrenciesSuccess,
  setSelectedMembershipProfileCurrency,
} from '@store/membership/MembershipProfileCurrencyReducer'
import {
  getMembershipProfilesSuccess,
  setSelectedMembershipProfile,
} from '@store/membership/MembershipProfileReducer'
import {
  getMembershipProfileTagsSuccess,
  setSelectedMembershipProfileTag,
} from '@store/membership/MembershipProfileTagReducer'
import {
  getParticipationStatusesSuccess,
  setSelectedParticipationStatus,
} from '@store/membership/ParticipationStatusReducer'
import { getPerksSuccess, setSelectedPerk } from '@store/membership/PerkReducer'
import { getPlansSuccess, setSelectedPlan } from '@store/membership/PlanReducer'
import {
  getProgramComplementaryItemsSuccess,
  setSelectedProgramComplementaryItem,
} from '@store/membership/ProgramComplementaryItemReducer'
import {
  getProgramCurrenciesSuccess,
  setSelectedProgramCurrency,
} from '@store/membership/ProgramCurrencyReducer'
import {
  getProgramsSuccess,
  setSelectedProgram,
} from '@store/membership/ProgramReducer'
import {
  getSubscriptionsSuccess,
  setSelectedSubscription,
} from '@store/membership/SubscriptionReducer'
import {
  getSubscriptionTagsSuccess,
  setSelectedSubscriptionTag,
} from '@store/membership/SubscriptionTagReducer'
import {
  getMembershipTransactionsSuccess,
  setSelectedMembershipTransaction,
} from '@store/membership/MembershipTransactionReducer'
import { AppDispatch } from '@store/store'
import { getVenueIntegrationsSuccess } from '@store/venue/VenueIntegrationReducer'
import {
  getAdyenConfigsSuccess,
  setSelectedAdyenConfig,
} from '@store/venue/integrations/AdyenConfigReducer'
import {
  getDominoConfigsSuccess,
  setSelectedDominoConfig,
} from '@store/venue/integrations/DominoConfigReducer'
import { getSevenroomsAudiencesSuccess } from '@store/venue/integrations/SevenroomsAudienceReducer'
import {
  getSevenroomsVenueGroupsSuccess,
  setSelectedSevenroomsVenueGroup,
} from '@store/venue/integrations/SevenroomsVenueGroupReducer'
import { InitialConfig as SBAsyncSelectInitialConfig } from '@supplement-bacon/react-async-select'
import { NormalizedData, SBModel } from '@supplement-bacon/react-toolkit/models'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import {
  DrawerTitleAction,
  SBRMAction,
  InitialConfig as SBRMInitialConfig,
} from '@supplement-bacon/sbrm-react'
import {
  ADMINS_INVITES_URL,
  ADMINS_URL,
  AUDIENCES_URL,
  BILLING_METHODS_URL,
  BUSINESS_PROFILE_STATUSES_URL,
  BUSINESS_PROFILS_URL,
  BUSINESS_VERIFIERS_URL,
  CLUSTERS_URL,
  COMPANIES_URL,
  COMPANY_CONTACTS_URL,
  COMPANY_STATUSES_URL,
  COMPLEMENTARY_ITEMS_URL,
  COUPONS_URL,
  CURRENCIES_URL,
  DAYS_URL,
  DOMINO_CONFIGS_URL,
  EVENTS_COLLECTIONS_URL,
  EVENTS_URL,
  EXTERNAL_BOOKING_API_KEYS_URL,
  FEATURED_VENUES_URL,
  INTEGRATIONS_ADYEN_CONFIGS_URL,
  INTEGRATIONS_SEVENROOMS_AUDIENCE_URL,
  INTEGRATIONS_SEVENROOMS_VENUE_GROUP_URL,
  LEGAL_DOCUMENTS_URL,
  LOYALTY_TIERS_URL,
  MEMBERSHIP_FORM_ANSWERS_URL,
  MEMBERSHIP_FORM_QUESTIONS_URL,
  MEMBERSHIP_FORM_QUESTION_OPTIONS_URL,
  MEMBERSHIP_MEMBERSHIP_PROFILE_CURRENCIES_URL,
  MEMBERSHIP_PLANS_URL,
  MEMBERSHIP_PROFILES_URL,
  MEMBERSHIP_PROFILE_COMPLEMENTARY_ITEMS_URL,
  MEMBERSHIP_PROFILE_TAGS_URL,
  MEMBERSHIP_PROGRAMS_URL,
  MEMBERSHIP_PROGRAM_COMPLEMENTARY_ITEMS_URL,
  MEMBERSHIP_PROGRAM_CURRENCIES_URL,
  MEMBERSHIP_SUBSCRIPTIONS_URL,
  MEMBERSHIP_SUBSCRIPTION_TAGS_URL,
  MEMBERSHIP_TRANSACTIONS_URL,
  NOTIFICATIONS_URL,
  NOTIFICATION_CONTENTS_URL,
  PARTICIPATIONS_STATUSES_URL,
  PARTICIPATIONS_URL,
  PERKS_URL,
  PERMISSIONS_URL,
  POLICIES_URL,
  RESERVATION_STATUSES_URL,
  ROLES_URL,
  SEATING_AREAS_URL,
  SETTINGS_URL,
  SHIFTS_URL,
  TEST_USERS_URL,
  USERS_URL,
  VENUES_URL,
  VENUE_COLLECTIONS_URL,
  VENUE_INTEGRATIONS_URL,
  VENUE_SEATING_AREAS_URL,
  VENUE_TAGS_URL,
  VENUE_TYPES_URL,
  WHATSAPP_BOT_SETTINGS_URL,
} from './urls'
import { testRecipientLabel } from './testRecipient'

enum Entity {
  admin = 'admin',
  adminInvite = 'adminInvite',
  role = 'role',
  permission = 'permission',
  audience = 'audience',
  venue = 'venue',
  venueType = 'venueType',
  cluster = 'cluster',
  featuredVenue = 'featuredVenue',
  seatingArea = 'seatingArea',
  venueTag = 'venueTag',
  venueSeatingArea = 'venueSeatingArea',
  venuesCollection = 'venuesCollection',
  user = 'user',
  reservationStatus = 'reservationStatus',
  menu = 'menu',
  loyaltyTiers = 'loyaltyTiers',
  setting = 'setting',
  whatsappBotSetting = 'whatsappBotSetting',
  notificationContent = 'notificationContent',
  testUsers = 'testUsers',
  notification = 'notification',
  event = 'event',
  segment = 'segment',
  legalDocument = 'legalDocument',
  legalDocumentVersion = 'legalDocumentVersion',

  /** INTEGRATIONS **/
  sevenroomsAudience = 'sevenroomsAudience',
  sevenroomsVenueGroup = 'sevenroomsVenueGroup',
  venueIntegration = 'venueIntegration',
  dominoConfig = 'dominoConfig',
  adyenConfig = 'adyenConfig',

  /** MEMBERSHIP **/
  membershipProgram = 'membershipProgram',
  membershipProgramCurrency = 'membershipProgramCurrency',
  membershipProfileCurrency = 'membershipProfileCurrency',
  membershipFormQuestion = 'membershipFormQuestion',
  membershipFormQuestionOption = 'membershipFormQuestionOption',
  membershipFormAnswer = 'membershipFormAnswer',
  membershipSubscriptions = 'membershipSubscriptions',
  membershipProfiles = 'membershipProfiles',
  membershipPlan = 'membershipPlan',
  membershipProfileTag = 'membershipProfileTag',
  subscriptionTag = 'subscriptionTag',
  coupon = 'coupon',
  perk = 'perk',
  eventParticipation = 'eventParticipation',
  eventParticipationStatus = 'eventParticipationStatus',
  eventsCollection = 'eventsCollection',
  programComplementaryItem = 'programComplementaryItem',
  membershipProfileComplementaryItem = 'membershipProfileComplementaryItem',
  membershipTransaction = 'membershipTransaction',

  /** BUSINESS LUNCH **/
  company = 'company',
  companyContact = 'companyContact',
  companyStatus = 'companyStatus',
  businessProfileStatus = 'businessProfileStatus',
  businessProfile = 'businessProfile',
  policy = 'policy',
  shift = 'shift',
  day = 'day',
  billingMethod = 'billingMethod',
  businessVerifier = 'businessVerifier',

  currency = 'currency',

  /** BALANCE **/
  complementaryItem = 'complementaryItem',

  /** EXTERNAL API **/
  externalBookingAPIKey = 'externalBookingAPIKey',
}

const generateConfig =
  () =>
  (
    dispatch: AppDispatch
  ): SBRMInitialConfig['entities'] &
    SBAsyncSelectInitialConfig<SBModel>['entities'] => ({
    [Entity.cluster]: {
      endpoint: CLUSTERS_URL,
      localizedLabel: 'cluster',
      options: { renderLabel: (item: SBModel) => (item as Cluster).en.title },
      form: ClusterForm,
      actionLayouts: {
        [SBRMAction.View]: {
          modal: { content: 'form' },
          buttons: {
            hideCancel: true,
            actionButtonPropsOverride: { style: { display: 'none' } },
          },
        },
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedCluster(id))
        },
      },
    },
    [Entity.venue]: {
      endpoint: VENUES_URL,
      localizedLabel: 'venue',
      options: {
        renderLabel: (item: SBModel) => (
          <Venue.Option model={item as VenueWithRelations} />
        ),
      },
      form: VenueForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedSeatingArea(id))
        },
      },
    },
    [Entity.audience]: {
      endpoint: AUDIENCES_URL,
      localizedLabel: 'audience',
      options: { renderLabel: (item: SBModel) => (item as Audience).title },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedAudience(id))
        },
      },
    },
    [Entity.segment]: {
      // Les segments sont des audiences custom : ils ciblent /audiences.
      endpoint: AUDIENCES_URL,
      localizedLabel: 'segment',
      options: { renderLabel: (item: SBModel) => (item as Segment).title },
      form: SegmentForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedSegment(id))
        },
      },
    },
    [Entity.notification]: {
      endpoint: NOTIFICATIONS_URL,
      localizedLabel: 'notification',
      options: { renderLabel: (item: SBModel) => (item as Notification).id },
      form: NotificationForm,
      actionLayouts: {
        [SBRMAction.View]: {
          modal: { content: 'form' },
          buttons: {
            hideCancel: true,
            actionButtonPropsOverride: { style: { display: 'none' } },
          },
        },
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedNotification(id))
        },
      },
    },
    [Entity.testUsers]: {
      endpoint: TEST_USERS_URL,
      localizedLabel: 'test users',
      options: {
        renderLabel: (item: SBModel) => testRecipientLabel(item as TestUser),
      },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedAudience(id))
        },
      },
    },
    [Entity.featuredVenue]: {
      endpoint: FEATURED_VENUES_URL,
      localizedLabel: 'featured venue',
      options: {
        renderLabel: (item: SBModel) => (item as FeaturedVenue).en.title,
      },
      form: FeaturedVenuesForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedFeaturedVenues(id))
        },
      },
    },
    [Entity.venueType]: {
      endpoint: VENUE_TYPES_URL,
      localizedLabel: 'venue type',
      options: { renderLabel: (item: SBModel) => (item as VenueType).name },
      form: VenueForm,
      defaultDisplay: 'segmented',
      switchDefaultDisplayToSelectAt: 100, // Make sure it's always display as radio
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedSeatingArea(id))
        },
      },
    },
    [Entity.seatingArea]: {
      endpoint: SEATING_AREAS_URL,
      localizedLabel: 'seating area',
      options: {
        renderLabel: (item: SBModel) => (item as SeatingArea).en.name,
      },
      form: SeatingAreaForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedSeatingArea(id))
        },
      },
    },
    [Entity.venuesCollection]: {
      endpoint: VENUE_COLLECTIONS_URL,
      localizedLabel: 'venue collection',
      options: {
        renderLabel: (item: SBModel) => (item as VenuesCollection).en.title,
      },
      form: VenuesCollectionForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedVenuesCollection(id))
        },
      },
    },
    [Entity.venueTag]: {
      endpoint: VENUE_TAGS_URL,
      localizedLabel: 'venue tag',
      options: { renderLabel: (item: SBModel) => (item as VenueTag).en.name },
      form: VenueTagForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedVenueTag(id))
        },
      },
    },

    /** INTEGRATION */
    [Entity.venueIntegration]: {
      endpoint: VENUE_INTEGRATIONS_URL,
      options: {
        renderLabel: (item: SBModel) => {
          const integration = item as VenueIntegration
          return `${integration.product} - ${integration.type} - ${integration.venueProviderId}`
        },
      },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedFormQuestion(id))
        },
      },
    },
    [Entity.sevenroomsAudience]: {
      endpoint: INTEGRATIONS_SEVENROOMS_AUDIENCE_URL,
      localizedLabel: 'Sevenrooms audience / API Key',
      options: {
        renderLabel: (item: SBModel) => (
          <SevenroomsAudience.Option model={item as SevenroomsAudienceModel} />
        ),
      },
      form: SevenroomsAudienceForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedFormQuestion(id))
        },
      },
    },
    [Entity.sevenroomsVenueGroup]: {
      endpoint: INTEGRATIONS_SEVENROOMS_VENUE_GROUP_URL,
      localizedLabel: 'Sevenrooms venue group',
      options: {
        renderLabel: (item: SBModel) => (
          <SevenroomsVenueGroup.Option
            model={item as SevenroomsVenueGroupModel}
          />
        ),
      },
      form: SevenroomsVenueGroupForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedSevenroomsVenueGroup(id))
        },
      },
    },

    /** MEMBERSHIP */
    [Entity.membershipProgram]: {
      endpoint: MEMBERSHIP_PROGRAMS_URL,
      localizedLabel: 'program',
      options: {
        renderLabel: (item: SBModel) => (item as Program).friendlyName,
      },
      form: ProgramForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedProgram(id))
        },
      },
    },
    [Entity.membershipProgramCurrency]: {
      endpoint: MEMBERSHIP_PROGRAM_CURRENCIES_URL,
      localizedLabel: 'program currency',
      options: {
        renderLabel: (item: SBModel) => (item as ProgramCurrency).currency,
      },
      form: ProgramCurrencyForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedProgramCurrency(id))
        },
      },
    },

    [Entity.membershipProfileCurrency]: {
      endpoint: MEMBERSHIP_MEMBERSHIP_PROFILE_CURRENCIES_URL,
      localizedLabel: 'membership profile currency',
      options: {
        renderLabel: (item: SBModel) =>
          (item as MembershipProfileCurrency).currency,
      },
      form: MembershipProfileCurrencyForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedMembershipProfileCurrency(id))
        },
      },
    },
    [Entity.membershipFormQuestion]: {
      endpoint: MEMBERSHIP_FORM_QUESTIONS_URL,
      localizedLabel: 'form question',
      options: {
        renderLabel: (item: SBModel) => (item as FormQuestion).en.title,
      },
      form: FormQuestionForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedFormQuestion(id))
        },
      },
    },
    [Entity.membershipFormQuestionOption]: {
      endpoint: MEMBERSHIP_FORM_QUESTION_OPTIONS_URL,
      localizedLabel: 'form answer',
      options: {
        renderLabel: (item: SBModel) => (item as FormQuestionOption).en.label,
      },
      form: FormQuestionOptionForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedFormQuestionOption(id))
        },
      },
    },
    [Entity.membershipFormAnswer]: {
      endpoint: MEMBERSHIP_FORM_ANSWERS_URL,
      localizedLabel: 'form answer',
      options: { renderLabel: (_) => <></> }, // Not used in SBAsyncSelect
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedFormAnswer(id))
        },
      },
    },
    [Entity.membershipSubscriptions]: {
      endpoint: MEMBERSHIP_SUBSCRIPTIONS_URL,
      localizedLabel: 'subscription',
      options: { renderLabel: (item: SBModel) => (item as Subscription).id },
      form: MembershipSubscriptionForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedSubscription(id))
        },
      },
    },
    [Entity.membershipPlan]: {
      endpoint: MEMBERSHIP_PLANS_URL,
      localizedLabel: 'plan',
      defaultDisplay: 'tree',
      options: { renderLabel: (item: SBModel) => (item as Plan).en.name },
      form: (<></>) as any,
      treeMode: {
        groupByKey: (item: SBModel) => (item as Plan).program.friendlyName,
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedPlan(id))
        },
      },
      displayEmpty: true,
      switchDefaultDisplayToSelectAt: 20,
    },
    [Entity.membershipProfiles]: {
      endpoint: MEMBERSHIP_PROFILES_URL,
      localizedLabel: 'membership profile',
      options: {
        renderLabel: (item: SBModel) => (item as MembershipProfile).id,
      },
      form: MembershipProfileForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedMembershipProfile(id))
        },
      },
    },
    [Entity.membershipProfileTag]: {
      endpoint: MEMBERSHIP_PROFILE_TAGS_URL,
      localizedLabel: 'membership tag',
      options: {
        renderLabel: (item: SBModel) => (item as MembershipProfileTag).name,
      },
      form: MembershipProfileTagForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedMembershipProfileTag(id))
        },
      },
    },
    [Entity.subscriptionTag]: {
      endpoint: MEMBERSHIP_SUBSCRIPTION_TAGS_URL,
      localizedLabel: 'subscription tag',
      options: {
        renderLabel: (item: SBModel) => (
          <SubscriptionTag.Option model={item as SubscriptionTagModel} />
        ),
      },
      form: SubscriptionTagForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedSubscriptionTag(id))
        },
      },
    },
    [Entity.venueSeatingArea]: {
      endpoint: VENUE_SEATING_AREAS_URL,
      localizedLabel: 'venue seating area',
      options: {
        renderLabel: (item: SBModel) => (item as VenueSeatingArea).id,
      },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedVenueSeatingArea(id))
        },
      },
    },
    [Entity.user]: {
      endpoint: USERS_URL,
      localizedLabel: 'user',
      options: {
        renderLabel: (item: SBModel) =>
          `${(item as User).firstName} ${(item as User).lastName}`,
      },
      form: UserForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedUser(id))
        },
      },
    },
    [Entity.reservationStatus]: {
      endpoint: RESERVATION_STATUSES_URL,
      localizedLabel: 'reservation status',
      // Short, global, unpaginated list (see the endpoint's own pagination
      // comment) — never worth a radio/segmented rendering.
      defaultDisplay: 'select',
      options: {
        renderLabel: (item: SBModel) =>
          (item as unknown as ReservationStatus).name,
      },
      form: (<></>) as any,
      methods: {
        setSelected: () => {},
      },
    },
    [Entity.menu]: {
      endpoint: '', // Not used in SBAsyncSelect
      localizedLabel: 'menu',
      options: { renderLabel: (_) => <></> }, // Not used in SBAsyncSelect
      form: MenuForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedMenu(id))
        },
      },
    },
    [Entity.admin]: {
      endpoint: ADMINS_URL, // Not used in SBAsyncSelect
      localizedLabel: 'admin',
      options: { renderLabel: (_) => <></> }, // Not used in SBAsyncSelect
      form: AdminForm,
      actionLayouts: {
        create: {
          title: DrawerTitleAction.Invite,
          drawer: {
            rightPanelContent: 'form',
          },
        },
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedAdmin(id))
        },
      },
    },
    [Entity.adminInvite]: {
      endpoint: ADMINS_INVITES_URL, // Not used in SBAsyncSelect
      localizedLabel: 'admin invite',
      options: { renderLabel: (_) => <></> }, // Not used in SBAsyncSelect
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedAdminInvite(id))
        },
      },
    },
    [Entity.role]: {
      endpoint: ROLES_URL,
      localizedLabel: 'role',
      options: {
        renderLabel: (item: SBModel) => (
          <Role.Avatar model={item as RoleModel} />
        ),
      },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedRole(id))
        },
      },
    },
    [Entity.permission]: {
      endpoint: PERMISSIONS_URL,
      localizedLabel: 'permission',
      options: { renderLabel: (_) => <></> },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedPermission(id))
        },
      },
    },
    [Entity.loyaltyTiers]: {
      endpoint: LOYALTY_TIERS_URL,
      localizedLabel: 'loyalty tier',
      options: {
        renderLabel: (item: SBModel) => `${(item as LoyaltyTierModel).title}`,
      },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedLoyaltyTier(id))
        },
      },
    },
    [Entity.setting]: {
      endpoint: SETTINGS_URL,
      localizedLabel: 'setting',
      options: { renderLabel: (_) => <></> },
      form: SettingForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedSetting(id))
        },
      },
    },
    [Entity.whatsappBotSetting]: {
      endpoint: WHATSAPP_BOT_SETTINGS_URL,
      localizedLabel: 'whatsappBotSetting',
      options: { renderLabel: (_) => <></> },
      form: WhatsappBotSettingForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedWhatsappBotSetting(id))
        },
      },
    },
    [Entity.notificationContent]: {
      endpoint: NOTIFICATION_CONTENTS_URL,
      localizedLabel: 'notification content',
      options: { renderLabel: (_) => <></> },
      form: NotificatinContentForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedNotificationContent(id))
        },
      },
    },
    [Entity.coupon]: {
      endpoint: COUPONS_URL,
      localizedLabel: 'coupon',
      options: { renderLabel: (item: SBModel) => (item as Coupon).code },
      form: CouponForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedCoupon(id))
        },
      },
    },
    [Entity.perk]: {
      endpoint: PERKS_URL,
      localizedLabel: 'benefit',
      options: { renderLabel: (item: SBModel) => (item as Perk).en.title },
      form: PerkForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedPerk(id))
        },
      },
    },
    [Entity.complementaryItem]: {
      endpoint: COMPLEMENTARY_ITEMS_URL,
      localizedLabel: 'complementaryItem',
      options: {
        renderLabel: (item: SBModel) => (item as ComplementaryItem).en.name,
      },
      form: ComplementaryItemForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedComplementaryItem(id))
        },
      },
    },
    [Entity.programComplementaryItem]: {
      endpoint: MEMBERSHIP_PROGRAM_COMPLEMENTARY_ITEMS_URL,
      localizedLabel: 'program complementary item',
      options: { renderLabel: (_) => <></> },
      form: ProgramComplementaryItemForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedProgramComplementaryItem(id))
        },
      },
    },
    [Entity.membershipProfileComplementaryItem]: {
      endpoint: MEMBERSHIP_PROFILE_COMPLEMENTARY_ITEMS_URL,
      localizedLabel: 'membership profile complementary item',
      options: { renderLabel: (_) => <></> },
      form: MembershipProfileComplementaryItemForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedMembershipProfileComplementaryItem(id))
        },
      },
    },
    // VIEW-ONLY (ticket 537, comment #13): a transaction is a payment record,
    // never created/updated/deleted from the BO.
    [Entity.membershipTransaction]: {
      endpoint: MEMBERSHIP_TRANSACTIONS_URL,
      localizedLabel: 'transaction',
      options: { renderLabel: (_) => <></> }, // Not used in SBAsyncSelect
      form: MembershipTransactionForm,
      actionLayouts: {
        [SBRMAction.View]: {
          modal: {
            content: 'form',
          },
          // SBRM always renders its primary button and its props map for
          // `view` is empty - an unlabelled green rectangle next to Cancel.
          // Hide it, and drop Cancel too: nothing to confirm on a read-only
          // record. NOT `saveOnClose`, which reroutes the close handler to a
          // save that does not exist for `view`, leaving the modal stuck open.
          buttons: {
            hideCancel: true,
            actionButtonPropsOverride: { style: { display: 'none' } },
          },
        },
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedMembershipTransaction(id))
        },
      },
    },
    [Entity.event]: {
      endpoint: EVENTS_URL,
      localizedLabel: 'event',
      options: {
        renderLabel: (item: unknown) => (
          <Event.Option model={item as EventModel} />
        ),
      },
      form: EventForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedEvent(id))
        },
      },
    },
    [Entity.eventParticipation]: {
      endpoint: PARTICIPATIONS_URL,
      localizedLabel: 'event participation',
      options: { renderLabel: (_) => <></> }, // Not used in SBAsyncSelect
      form: EventParticipation.Form,
      actionLayouts: {
        [SBRMAction.View]: {
          modal: {
            content: 'form',
          },
        },
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedParticipation(id))
        },
      },
    },
    [Entity.eventParticipationStatus]: {
      endpoint: PARTICIPATIONS_STATUSES_URL,
      localizedLabel: 'event participation status',
      options: { renderLabel: (item: any) => <>{item.name}</> },
      form: ParticipationStatusForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedParticipationStatus(id))
        },
      },
    },
    [Entity.eventsCollection]: {
      endpoint: EVENTS_COLLECTIONS_URL,
      localizedLabel: 'events collection',
      options: {
        renderLabel: (item: SBModel) => (item as EventsCollection).en.title,
      },
      form: EventsCollectionForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedEventsCollection(id))
        },
      },
    },
    [Entity.company]: {
      endpoint: COMPANIES_URL,
      localizedLabel: 'company',
      options: { renderLabel: (item: SBModel) => (item as Company).name },
      form: CompanyForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedCompany(id))
        },
      },
    },

    [Entity.companyContact]: {
      endpoint: COMPANY_CONTACTS_URL,
      localizedLabel: 'company contact',
      options: {
        renderLabel: (item: SBModel) => (item as CompanyContact).lastName,
      },
      form: CompanyContactForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedCompanyContact(id))
        },
      },
    },
    [Entity.companyStatus]: {
      endpoint: COMPANY_STATUSES_URL,
      localizedLabel: 'company statuses',
      options: { renderLabel: (item: SBModel) => (item as CompanyStatus).name },
      form: CompanyStatusForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedCompanyStatus(id))
        },
      },
    },
    [Entity.businessProfileStatus]: {
      endpoint: BUSINESS_PROFILE_STATUSES_URL,
      localizedLabel: 'employee statuses',
      options: {
        renderLabel: (item: SBModel) => (item as BusinessProfileStatus).name,
      },
      form: BusinessStatusForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedBusinessProfileStatus(id))
        },
      },
    },
    [Entity.businessProfile]: {
      endpoint: BUSINESS_PROFILS_URL,
      localizedLabel: 'employee',
      options: { renderLabel: (item: SBModel) => (item as BusinessProfile).id },
      form: BusinessProfilForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedBusinessProfile(id))
        },
      },
      actionLayouts: {
        [SBRMAction.View]: {
          modal: {
            content: 'form',
          },
        },
      },
    },
    [Entity.policy]: {
      endpoint: POLICIES_URL,
      localizedLabel: 'policy',
      options: { renderLabel: (item: SBModel) => (item as Policy).name },
      form: PolicyForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedPolicy(id))
        },
      },
    },
    [Entity.shift]: {
      endpoint: SHIFTS_URL,
      localizedLabel: 'shift',
      options: { renderLabel: (_) => <></> },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedShift(id))
        },
      },
    },
    [Entity.day]: {
      endpoint: DAYS_URL,
      localizedLabel: 'day',
      options: { renderLabel: (_) => <></> },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedDay(id))
        },
      },
    },
    [Entity.billingMethod]: {
      endpoint: BILLING_METHODS_URL,
      localizedLabel: 'billing Method',
      options: { renderLabel: (_) => <></> },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedBillingMethod(id))
        },
      },
    },
    [Entity.businessVerifier]: {
      endpoint: BUSINESS_VERIFIERS_URL,
      localizedLabel: 'business verifier',
      options: { renderLabel: (_) => <></> },
      form: BusinessVerifierForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedBusinessVerifier(id))
        },
      },
    },
    [Entity.dominoConfig]: {
      endpoint: DOMINO_CONFIGS_URL,
      localizedLabel: 'Trivec configuration',
      options: { renderLabel: (_) => <></> },
      form: DominoConfigForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedDominoConfig(id))
        },
      },
    },
    [Entity.adyenConfig]: {
      endpoint: INTEGRATIONS_ADYEN_CONFIGS_URL,
      localizedLabel: 'Adyen configuration',
      options: {
        renderLabel: (item: SBModel) => (item as AdyenConfig).merchantAccount,
      },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedAdyenConfig(id))
        },
      },
    },
    [Entity.currency]: {
      endpoint: CURRENCIES_URL,
      localizedLabel: 'Currency',
      options: {
        renderLabel: (item: SBModel) => {
          const { isoCode, symbol, name } = item as Currency
          return `${isoCode} - ${symbol} - ${name}`
        },
      },
      form: (<></>) as any,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedCurrency(id))
        },
      },
    },
    [Entity.externalBookingAPIKey]: {
      endpoint: EXTERNAL_BOOKING_API_KEYS_URL,
      localizedLabel: 'External booking API key',
      options: {
        renderLabel: (item: SBModel) => (item as ExternalBookingAPIKey).name,
      },
      form: ExternalBookingAPIKeyForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedExternalBookingAPIKey(id))
        },
      },
    },
    [Entity.legalDocument]: {
      endpoint: LEGAL_DOCUMENTS_URL,
      localizedLabel: 'legal document',
      options: {
        renderLabel: (item: SBModel) => (item as LegalDocument).friendlyName,
      },
      form: LegalDocumentForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedLegalDocument(id))
        },
      },
    },
    [Entity.legalDocumentVersion]: {
      endpoint: '', // Not used in SBAsyncSelect
      localizedLabel: 'legal document version',
      options: { renderLabel: (_) => <></> }, // Not used in SBAsyncSelect
      form: LegalDocumentVersionForm,
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedLegalDocumentVersion(id))
        },
      },
    },
  })

SBAPI.fillStoreWithNormalizedData =
  (normalizedData: NormalizedData) => (dispatch: AppDispatch) => {
    // To be defined by package consumer
    dispatch(getVenuesSuccess(normalizedData.entities.venue ?? {}))
    dispatch(getVenueTypesSuccess(normalizedData.entities.venueType ?? {}))
    dispatch(getSeatingAreasSuccess(normalizedData.entities.seatingArea ?? {}))
    dispatch(getVenueTagsSuccess(normalizedData.entities.venueTag ?? {}))
    dispatch(
      getMembershipProfileTagsSuccess(
        normalizedData.entities.membershipProfileTag ?? {}
      )
    )
    dispatch(
      getSubscriptionTagsSuccess(normalizedData.entities.subscriptionTag ?? {})
    )
    dispatch(getClustersSuccess(normalizedData.entities.cluster ?? {}))
    dispatch(
      getVenuesCollectionsSuccess(
        normalizedData.entities.venuesCollection ?? {}
      )
    )
    dispatch(
      getVenueSeatingAreasSuccess(
        normalizedData.entities.venueSeatingArea ?? {}
      )
    )
    dispatch(
      getFeaturedVenuesSuccess(normalizedData.entities.featuredVenue ?? {})
    )
    dispatch(getUsersSuccess(normalizedData.entities.user ?? {}))
    dispatch(getMenusSuccess(normalizedData.entities.menu ?? {}))
    dispatch(getAdminsSuccess(normalizedData.entities.admin ?? {}))
    dispatch(
      getExternalBookingAPIKeysSuccess(
        normalizedData.entities.externalBookingAPIKey ?? {}
      )
    )
    dispatch(getAdminInvitesSuccess(normalizedData.entities.adminInvite ?? {}))
    dispatch(getRolesSuccess(normalizedData.entities.role ?? {}))
    dispatch(getPermissionsSuccess(normalizedData.entities.permission ?? {}))
    dispatch(getLoyaltyTiersSuccess(normalizedData.entities.loyaltyTier ?? {}))
    dispatch(
      getLegalDocumentsSuccess(normalizedData.entities.legalDocument ?? {})
    )
    dispatch(
      getLegalDocumentVersionsSuccess(
        normalizedData.entities.legalDocumentVersion ?? {}
      )
    )
    dispatch(getSettingsSuccess(normalizedData.entities.setting ?? {}))
    dispatch(
      getWhatsappBotSettingsSuccess(
        normalizedData.entities.whatsappBotSetting ?? {}
      )
    )
    dispatch(
      getNotificationContentsSuccess(
        normalizedData.entities.notificationContent ?? {}
      )
    )
    dispatch(getAudiencesSuccess(normalizedData.entities.audience ?? {}))
    dispatch(getSegmentsSuccess(normalizedData.entities.segment ?? {}))
    dispatch(
      getFormQuestionsSuccess(normalizedData.entities.formQuestion ?? {})
    )
    dispatch(
      getFormQuestionOptionsSuccess(
        normalizedData.entities.formQuestionOption ?? {}
      )
    )
    dispatch(getFormAnswersSuccess(normalizedData.entities.formAnswer ?? {}))
    dispatch(getTestUsersSuccess(normalizedData.entities.testUsers ?? {}))
    dispatch(
      getNotificationsSuccess(normalizedData.entities.notification ?? {})
    )
    dispatch(getProgramsSuccess(normalizedData.entities.program ?? {}))
    dispatch(
      getSubscriptionsSuccess(normalizedData.entities.subscription ?? {})
    )
    dispatch(
      getMembershipTransactionsSuccess(
        normalizedData.entities.membershipTransaction ?? {}
      )
    )
    dispatch(
      getMembershipIncomingRenewalsSuccess(
        normalizedData.entities.membershipIncomingRenewal ?? {}
      )
    )
    dispatch(
      getMembershipProfilesSuccess(
        normalizedData.entities.membershipProfile ?? {}
      )
    )
    dispatch(getCouponsSuccess(normalizedData.entities.coupon ?? {}))
    dispatch(getPerksSuccess(normalizedData.entities.perk ?? {}))
    dispatch(
      getComplementaryItemsSuccess(
        normalizedData.entities.complementaryItem ?? {}
      )
    )
    dispatch(
      getProgramComplementaryItemsSuccess(
        normalizedData.entities.programComplementaryItem ?? {}
      )
    )
    dispatch(
      getMembershipProfileCurrenciesSuccess(
        normalizedData.entities.membershipProfileCurrency ?? {}
      )
    )
    dispatch(
      getProgramCurrenciesSuccess(normalizedData.entities.programCurrency ?? {})
    )
    dispatch(
      getMembershipProfileComplementaryItemsSuccess(
        normalizedData.entities.membershipProfileComplementaryItem ?? {}
      )
    )
    dispatch(getEventsSuccess(normalizedData.entities.event ?? {}))
    dispatch(
      getEventParticipationsSuccess(
        normalizedData.entities.eventParticipation ?? {}
      )
    )
    dispatch(
      getParticipationStatusesSuccess(
        normalizedData.entities.eventParticipationStatus ?? {}
      )
    )
    dispatch(
      getEventsCollectionsSuccess(
        normalizedData.entities.eventsCollection ?? {}
      )
    )
    dispatch(
      getSevenroomsAudiencesSuccess(
        normalizedData.entities.sevenroomsAudience ?? {}
      )
    )
    dispatch(
      getSevenroomsVenueGroupsSuccess(
        normalizedData.entities.sevenroomsVenueGroup ?? {}
      )
    )
    dispatch(
      getVenueIntegrationsSuccess(
        normalizedData.entities.venueIntegration ?? {}
      )
    )
    dispatch(getPlansSuccess(normalizedData.entities.plan ?? {}))
    dispatch(getCompaniesSuccess(normalizedData.entities.company ?? {}))
    dispatch(
      getCompanyContactsSuccess(normalizedData.entities.companyContact ?? {})
    )

    dispatch(
      getCompanyStatusesSuccess(normalizedData.entities.companyStatus ?? {})
    )
    dispatch(
      getBusinessProfileStatusesSuccess(
        normalizedData.entities.businessProfileStatus ?? {}
      )
    )
    dispatch(
      getBusinessProfilesSuccess(normalizedData.entities.businessProfile ?? {})
    )
    dispatch(getPoliciesSuccess(normalizedData.entities.policy ?? {}))
    dispatch(getShiftsSuccess(normalizedData.entities.shift ?? {}))
    dispatch(getDaysSuccess(normalizedData.entities.day ?? {}))
    dispatch(
      getBillingMethodsSuccess(normalizedData.entities.billingMethod ?? {})
    )
    dispatch(getReservationsSuccess(normalizedData.entities.reservation ?? {}))
    dispatch(
      getBusinessVerifiersSuccess(
        normalizedData.entities.businessVerifier ?? {}
      )
    )
    dispatch(
      getDominoConfigsSuccess(normalizedData.entities.dominoConfig ?? {})
    )
    dispatch(getAdyenConfigsSuccess(normalizedData.entities.adyenConfig ?? {}))
    dispatch(getCurrenciesSuccess(normalizedData.entities.currency ?? {}))
  }

export { Entity, generateConfig }
